import { Navbar } from "@/components/Navbar";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";

const CloudTechSolutionsCase = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/case-studies">Case Studies</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink href="/case-studies/technology">Technology</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink>CloudTech Solutions</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="max-w-4xl mx-auto">
          <div className="relative h-96 mb-12 rounded-xl overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
              alt="CloudTech Solutions"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-blue-900/40" />
          </div>

          <h1 className="text-4xl font-bold text-blue-900 mb-4">
            CloudTech Solutions: Cloud Infrastructure Optimization
          </h1>
          
          <div className="bg-blue-50 p-6 rounded-lg mb-12">
            <h2 className="text-xl font-semibold text-blue-900 mb-4">Key Results</h2>
            <div className="grid sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-700 mb-2">40%</div>
                <div className="text-blue-600">Cost Reduction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-700 mb-2">2x</div>
                <div className="text-blue-600">Performance Increase</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-700 mb-2">99.9%</div>
                <div className="text-blue-600">Uptime Achieved</div>
              </div>
            </div>
          </div>

          <div className="prose prose-blue max-w-none mb-12">
            <h2>The Challenge</h2>
            <p>
              CloudTech Solutions was experiencing rapid growth but faced challenges with rising cloud infrastructure costs and scalability issues. They needed a solution that would optimize their cloud resources while maintaining high performance.
            </p>

            <h2>Our Approach</h2>
            <p>
              We implemented a comprehensive cloud optimization strategy that included:
            </p>
            <ul>
              <li>Infrastructure audit and assessment</li>
              <li>Resource utilization optimization</li>
              <li>Automated scaling solutions</li>
              <li>Cost monitoring and optimization tools</li>
            </ul>

            <h2>The Results</h2>
            <p>
              Through our optimization efforts, CloudTech Solutions achieved significant improvements in both cost efficiency and performance. The implemented solutions resulted in a 40% reduction in cloud costs while doubling the system's performance.
            </p>
          </div>

          <div className="flex justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700">
                Start Your Success Story
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudTechSolutionsCase;